"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Underline = void 0;
const extension_underline_1 = require("@tiptap/extension-underline");
exports.Underline = extension_underline_1.Underline.extend({
    parseHTML() {
        const parentConfig = this.parent?.() ?? [];
        return [
            ...parentConfig,
            {
                style: 'text-decoration-line',
                consuming: false,
                getAttrs: (value) => value.toString().includes('underline') && null,
            },
        ];
    },
});
//# sourceMappingURL=underline.js.map